// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1He_f","label":"Radio_label__1Q8u1","checkMark":"Radio_checkMark__2h1iZ","disabled":"Radio_disabled__4Fk-3"};